import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      &:hover {\n        ", " {\n          fill: ", ";\n        }\n      }\n      &:active {\n        ", " {\n          fill: ", ";\n        }\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { ICON_TINY_SIZE, INFO_WITH_ICONS_TINY_MARGIN } from '../../constants';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY, SENSATION_WHITE } from '../../colors';
import DropdownDownIcon from '@tourlane/iconography/Glyphs/Navigation/DropdownDown';
import InfoButton from './InfoButton';
import IconWithRotation from '../../SvgIcon/IconWithRotation';
import { omitProps } from '../../helpers/elements';
import InfoWithIconsSimple from '../InfoWithIcons/InfoWithIconsSimple';
var StyledDropdownDownIcon = styled(DropdownDownIcon)(_templateObject()); // Workaround to be able to style inner SVG

var StyledInfoButton = styled(omitProps(function (props, ref) {
  return /*#__PURE__*/React.createElement(InfoButton, _extends({
    ref: ref
  }, props));
}, ['iconColor', 'iconColorDisabled', 'iconColorHover', 'iconColorActive']))(_templateObject2(), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "cursor: not-allowed;";
}, function (_ref2) {
  var disabled = _ref2.disabled,
      iconColorHover = _ref2.iconColorHover,
      iconColorActive = _ref2.iconColorActive;
  return !disabled && css(_templateObject3(), StyledDropdownDownIcon, iconColorHover, StyledDropdownDownIcon, iconColorActive);
});

var _ref4 = /*#__PURE__*/React.createElement(StyledDropdownDownIcon, null);

var InfoButtonWithDropdown = /*#__PURE__*/React.forwardRef(function (_ref3, forwardedRef) {
  var _ref3$inverse = _ref3.inverse,
      inverse = _ref3$inverse === void 0 ? false : _ref3$inverse,
      _ref3$rotated = _ref3.rotated,
      rotated = _ref3$rotated === void 0 ? false : _ref3$rotated,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$iconSize = _ref3.iconSize,
      iconSize = _ref3$iconSize === void 0 ? ICON_TINY_SIZE : _ref3$iconSize,
      _ref3$iconMargin = _ref3.iconMargin,
      iconMargin = _ref3$iconMargin === void 0 ? INFO_WITH_ICONS_TINY_MARGIN : _ref3$iconMargin,
      iconColorProp = _ref3.iconColor,
      _ref3$iconColorHover = _ref3.iconColorHover,
      iconColorHover = _ref3$iconColorHover === void 0 ? ADVENTURE_GREEN : _ref3$iconColorHover,
      _ref3$iconColorActive = _ref3.iconColorActive,
      iconColorActive = _ref3$iconColorActive === void 0 ? ADVENTURE_GREEN_FOCUSED : _ref3$iconColorActive,
      _ref3$iconColorDisabl = _ref3.iconColorDisabled,
      iconColorDisabled = _ref3$iconColorDisabl === void 0 ? ELEMENT_GRAY : _ref3$iconColorDisabl,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, ["inverse", "rotated", "disabled", "iconSize", "iconMargin", "iconColor", "iconColorHover", "iconColorActive", "iconColorDisabled", "children"]);

  var iconColor = iconColorProp != null ? iconColorProp : inverse ? SENSATION_WHITE : ELEMENT_GRAY;
  return /*#__PURE__*/React.createElement(StyledInfoButton, _extends({
    noFocus: true,
    clickable: !disabled,
    ref: forwardedRef,
    disabled: disabled,
    iconColor: iconColor,
    iconColorHover: iconColorHover,
    iconColorActive: iconColorActive,
    iconColorDisabled: iconColorDisabled
  }, props), /*#__PURE__*/React.createElement(InfoWithIconsSimple, {
    iconRight: /*#__PURE__*/React.createElement(IconWithRotation, {
      pointer: !disabled,
      rotated: rotated,
      size: iconSize,
      icon: _ref4,
      color: disabled ? iconColorDisabled : iconColor,
      colorHover: disabled ? iconColorDisabled : iconColorHover
    }),
    iconRightMargin: iconMargin
  }, children));
});
export default InfoButtonWithDropdown;